"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.preview.title': 'Detalles de la Empresa',
    'company.preview.failedToLoad': 'Error al cargar la información de la empresa',
    'company.preview.noCompany': 'No hay información de empresa disponible',
    'company.preview.section.basic_info': 'Información Básica',
    'company.preview.section.status': 'Estado',
    'company.preview.section.location': 'Ubicación',
    'company.preview.section.additional': 'Información Adicional',
};
